import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';
import { Environment } from '../../../environment';

const getDiagramas = async (): Promise<string | ApiException> => {
  try {
    const { data } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Diagramas`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    if (data) {
      return data as string;
    } else {
      return new ApiException('Não foi possível exibir os diagramas');
    }
  } catch (error: any) {
    console.error(error);
    return new ApiException(
      error.data.data.erro || 'Erro ao buscar os dados dos diagramas'
    );
  }
};

export const DiagramasService = {
  getDiagramas,
};
